


import TiwiMixin from '../mixins/TiwiMixin'
import ActivityIndicator from './ActivityIndicator'

export default {
  mixins: [ TiwiMixin ],
  props: {
    
    terms: {
      required: false,
      type: Object,
      default:{
        enabled: false,
        link: '',
      }
    },
  },
  components: { ActivityIndicator },
  data: () => {
		return {
      show_password: false,
      validation_errors: {},
      form_submitted: false,
      userdata:{
        first_name: '',
        last_name: '',
        nick_name: '',
        role: '',
        
        email: '',
        
        password: '',
        password_confirmation: '',
        terms_acceptance: false,
        form_disabled: false,
        
      }
		}
	},
  methods:{
    clickRegister: function(){

      var self = this;
      self.setLoading(true);

      var post_data = {...this.userdata, terms_acceptance_required: this.terms.enabled};


      this.api.post('user/register', post_data )
        .then( (response) => {

          if( response.data.success ){
            self.toast.success( response.data.message );
            self.form_submitted = true;
            self.form_disabled = true;

            if(response.data.redirect){
              setTimeout(function(){ window.location.href = response.data.redirect; }, 1000);
            }
              
          }
          else{
            self.toast.error( response.data.message );
            if( response.data.validation_errors )
              self.validation_errors = response.data.validation_errors;
          }
            

          

         })
        .catch( (error) => { 
          self.toast.error( 'Errore nella richiesta' );
        })
        .finally( () => self.setLoading(false) )

    } 
  },

  computed: {
    formDisabled: function(){ return this.loading || this.form_disabled; },
  }
}
